import React from "react";
import LandingLayout from "../components/landing/LandingLayout";
import HeroSection from "../components/landing/HeroSection";
import ComparisonSection from "../components/landing/ComparisonSection";
import TechFeaturesSection from "../components/landing/TechFeaturesSection";
import StatsSection from "../components/landing/StatsSection";
import TestimonialsSection from "../components/landing/TestimonialsSection";
import FinalCTASection from "../components/landing/FinalCTASection";

const Home = () => {
  return (
    <LandingLayout>
      <HeroSection />
      <ComparisonSection />
      <TechFeaturesSection />
      <StatsSection />
      <TestimonialsSection />
      <FinalCTASection />
    </LandingLayout>
  );
};

export default Home;
